import React, { useState, useEffect } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { countInventoryByCommodity } from "../../../graphql/report-queries";

import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

import { useNotify, TopToolbar } from "react-admin";

import { ForceTitle } from "../../../components/common/ForceTitle";
import { BackButton } from "../../../components/common/BackButton";
import { logError } from "../../../utils/appUtils";
import {
  colorsDark,
  colorsLight,
  InventoryStatus,
} from "../../../utils/constants";
import Title from "../Title";

const InventoryByLoadType = () => {
  const notify = useNotify();
  const [data, setData] = useState([]);
  const dataMap = {};
  const height = window.innerHeight * 0.6;

  useEffect(() => {
    getInventoryData();
  }, []);

  const getInventoryData = async () => {
    let tempData = [];
    let commodityMap = {};
    const limit = 500;
    try {
      const searchInput = {
        sort: { field: "inboundShipmentId", direction: "asc" },
        filter: {
          reloadYardId: { eq: window.appUser?.reloadYardId },
          status: { eq: InventoryStatus.STORED },
        },
        limit,
      };
      let nextToken = true;
      let inventories = [];
      while (nextToken) {
        const input =
          nextToken === true ? searchInput : { nextToken, ...searchInput };
        const result = await API.graphql(
          graphqlOperation(countInventoryByCommodity, input)
        );
        inventories = inventories.concat(result.data.searchInventorys.items);
        if (result.data.searchInventorys.items.length < limit) break;
        nextToken = result.data.searchInventorys.nextToken;
      }

      inventories.forEach((inventory) => {
        let commodity = inventory?.reloadYardCommodity?.commodity?.id;
        let inbound = inventory.inboundShipmentId;

        if (dataMap[commodity]) {
          dataMap[commodity] = {
            ...dataMap[commodity],
            [inbound]: dataMap[commodity][inbound]
              ? dataMap[commodity][inbound] + 1
              : 1,
          };
        } else {
          commodityMap[commodity] =
            inventory?.reloadYardCommodity?.commodity?.name;
          dataMap[commodity] = { [inbound]: 1 };
        }
      });

      Object.keys(dataMap).forEach((commodity, idx) => {
        let count = 0;
        Object.keys(dataMap[commodity]).forEach((inbound) => {
          count += dataMap[commodity][inbound];
        });
        tempData[idx] = { name: commodityMap[commodity], cars: count };
      });

      setData(tempData);
    } catch (err) {
      logError("InventoryByCommodity:getInventoryData", err, notify);
    }
  };

  return (
    <>
      <div style={{ display: "none" }}>
        <ForceTitle title="Reports" />
      </div>
      <TopToolbar>
        <Title>Inventory by Commodity</Title>
        <BackButton basePath="/reports" />
      </TopToolbar>
      <ResponsiveContainer height={height}>
        <PieChart margin={{ top: 5, right: 30, bottom: 5, left: 20 }}>
          <Tooltip />
          <Legend
            layout="vertical"
            align="left"
            verticalAlign="middle"
            height={36}
          />
          <Pie
            data={data}
            dataKey="cars"
            nameKey="name"
            innerRadius={height / 3}
            outerRadius={height / 2}
            fill="#8884d8"
            paddingAngle={5}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={index % 2 === 0 ? colorsDark[index] : colorsLight[index]}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </>
  );
};

export default InventoryByLoadType;
